import { DebtTypeFromBilling } from '../../../../common/model/account/debtType';
import { AccountsChargesSelectionState } from '../../../models/accounts/chargesSelection';
import { AccountServicesViewModel } from '../../../../common/model/account/accountServicesViewModel';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActionType } from '../../../actions/model';
import { AccountViewModel } from '../../../../common/model/account/accountViewModel';
import _ from 'lodash';


const initialState: AccountsChargesSelectionState = {
    amountSelection: {},
    activitySelection: {},
};

export const accountsChargesSelection = createSlice({
    name: '@@vp/accounts/chargesSelection',
    initialState,
    reducers: {
        resetAccountsChargesSelectionState(state): void {
            state.amountSelection = initialState.amountSelection;
            state.activitySelection = initialState.activitySelection;
        },
        setAccountsChargesAmountSelection(state, action: PayloadAction<AccountsChargesSelectionState['amountSelection']>): void {
            state.amountSelection = action.payload;
        },
        setAccountChargeAmountSelectionForService(state, action: PayloadAction<{ accountId: AccountViewModel['id'], codeGroup: number, debtType: DebtTypeFromBilling, accountServiceId: AccountServicesViewModel['id'], amount: number; }>): void {
            const { accountId, codeGroup, debtType, accountServiceId, amount } = action.payload;
            _.set(state.amountSelection, [accountId, codeGroup, debtType, 'separatableServices', accountServiceId].map(String), amount);
        },
        setAccountChargeAmountSelectionForAtomicServiceGroup(state, action: PayloadAction<{ accountId: AccountViewModel['id'], codeGroup: number, debtType: DebtTypeFromBilling, amount: number; }>): void {
            const { accountId, codeGroup, debtType, amount } = action.payload;
            _.set(state.amountSelection, [accountId, codeGroup, debtType, 'atomicServices'].map(String), amount);
        },
        setAccountsChargesActivitySelection(state, action: PayloadAction<AccountsChargesSelectionState['activitySelection']>): void {
            state.activitySelection = action.payload;
        },
        setAccountChargeActivitySelectionForSeparatableServices(state, action: PayloadAction<{ accountId: AccountViewModel['id'], codeGroup: number, debtType: DebtTypeFromBilling, selectedServiceIds: AccountServicesViewModel['id'][]; }>): void {
            const { accountId, codeGroup, debtType, selectedServiceIds } = action.payload;
            _.set(state.activitySelection, [accountId, codeGroup, debtType, 'separatableServices'].map(String), selectedServiceIds);
        },
        setAccountChargeActivitySelectionForAtomicServiceGroup(state, action: PayloadAction<{ accountId: AccountViewModel['id'], codeGroup: number, debtType: DebtTypeFromBilling, selected: boolean; }>): void {
            const { accountId, codeGroup, debtType, selected } = action.payload;
            _.set(state.activitySelection, [accountId, codeGroup, debtType, 'atomicServices'].map(String), selected);
        },
    },
    extraReducers: {
        [ActionType.LOGOUT]: (): AccountsChargesSelectionState => initialState,
    }
});

export const {
    resetAccountsChargesSelectionState,
    setAccountsChargesAmountSelection,
    setAccountChargeAmountSelectionForService,
    setAccountChargeAmountSelectionForAtomicServiceGroup,
    setAccountsChargesActivitySelection,
    setAccountChargeActivitySelectionForSeparatableServices,
    setAccountChargeActivitySelectionForAtomicServiceGroup,
} = accountsChargesSelection.actions;
